"use client";

import { useCallback, useState } from "react";

/** Single-open accordion (matches redesign prototype). */
export function useFaqAccordion(initialOpen: number | null = null) {
  const [openIndex, setOpenIndex] = useState<number | null>(initialOpen);

  const toggle = useCallback((index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  }, []);

  const isOpen = useCallback(
    (index: number) => openIndex === index,
    [openIndex],
  );

  return { openIndex, toggle, isOpen };
}
